<template>
  <Loader v-if="loading"/>
  <section v-else>
    <button
      class="button is-info mb-2"
      v-if="!showCreateArtFormComment"
      @click="showCreateArtFormComment = true">Add Comment</button>
    <CreateArtFormComment
      v-else
      :videoID=videoID
      :currentTime = "currentTime"
      @close="showCreateArtFormComment = false"
      />
    <div v-for="comment in comments">
      <ArtFormComment :comment=comment />
    </div>
  </section>
</template>

<script>
import Loader from './Loader'

import ArtFormComment from './ArtFormComment.vue'
import MultiAnswer from './MultiAnswer.vue'
import CreateArtFormComment from './CreateArtFormComment.vue'

import { router } from '../main.js'

import axios from 'axios'
import store from '../store.js'

const is404Error = error =>
  error.response != null && error.response.status === 404

export default {
  name: 'ArtsForm',
  components: {
    Loader,
    MultiAnswer,
    CreateArtFormComment,
    ArtFormComment,
  },
  props: {
    videoID: {
      type: Number,
      required: true,
    },
    currentTime: {
      type: Number,
      required: true
    }
  },
  async mounted () {
    await this.loadComments()
    this.loading = false
  },
  computed: {
    user () {
      return store.state.user
    },
    id () {
      return this.artform.id
    },
    comments () {
      return store.state.artformcomments
    }
  },
  data () {
    return {
      loading: true,
      showCreateArtFormComment: false,
    }
  },
  methods: {
    async save (id, showToast = true) {
      const data = this.comments.find(x => x.id === id)
      return axios.patch(`/api/v1/artformcomments/${id}/`, data,
        { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } })
      .then(() => {
        if (showToast) {
          store.commit('notify', { message: 'Saved successfully', level: 'info' })
        }
        console.log('saved...')
      })
      .catch(error => store.dispatch(store.action.generalErrorHandler, { error, message: "Uh Oh. It couldn't save." }))
    },
    async loadComments () {
      return axios.get(`/api/v1/videos/${this.videoID}/observationcomments/`,
        { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } })
      .then(response => {
        store.state.artformcomments = response.data
      })
      .catch(error => {
        console.warn('error fetching comments', error)
        if (is404Error(error)) {
          router.replace('/404')
        }
        throw error
      })
    },
  }
}
</script>
<style lang="scss" scoped>

#intro {
  margin-bottom: 2rem;
}

textarea {
  margin-bottom: 1rem;
}

p {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

h1 {
  border-bottom: 2px solid #000;
  font-weight: 500;
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

.exercise--title {
  margin-bottom: 0.5rem;
}

.no-questions {
  text-align: center;
  font-style: italic;
  margin-bottom: 5px;
  font-size: 2rem;
  font-weight: 300;
}

ul {
  list-style: circle;
  padding-left: 2rem;
  margin-top: .25rem;
  margin-bottom: .25rem;
}

.left {
  padding-left: 3rem;
}

div.menu-list > div {
  text-align: center;
  background-color: #fff;
  padding: .5rem;
  list-style: none;
  margin-top: .5rem;
  border: 2px solid #000;
  box-shadow: 4px -4px #23c6c8;
  font-size: 1rem;
  cursor: pointer;
  color: black;
}

.upside-down {
  transform: rotate( 180deg );
  transition: transform 500ms ease;
}

textarea {
  margin-top: 1rem;
  border: 2px solid #808080;
  box-shadow: 4px -4px #23c6c8;
  font-size: 1rem;
  padding: 4px 6px 4px 6px;
  width: 100%;
  min-height: 180px;
}

.dropdown-content {
  margin-top: 0rem !important;
  border-top: none !important;
  box-shadow: none !important;
  max-width: 750px;
  display: block !important;

  span {
    display: block !important;
    font-size: 1rem;
  }
}

.dropdown-top {
  width: 750px;
}

.xart-form {
  max-height: 800px;
  overflow: scroll;
}

.answer-blocks {
  min-height: 180px;
  font-size: 1rem;
  padding: 4px 6px 4px 6px;
  margin-right: 1rem;
  margin-top: 1rem;
  border: 2px solid #363636;
  box-shadow: 4px -4px #23c6c8;
  width: 100%;
  background-color: #eaeaea;
  word-wrap: break-word;
}

</style>



// WEBPACK FOOTER //
// ArtsFormComments.vue?64f4f7e8